import React, { Fragment, useEffect, useContext } from "react";
import { SessionContext } from '../context/sessionContext';

import { Button } from "react-bootstrap";
import Modal from 'react-bootstrap/Modal';

//EX 15-10-2026 (fase 3 - paso 3): el cascaron del formulario de EDICION. La estructura compartida con
//el alta (barra de estado, encabezado con el titulo y los tres botones de pestaña, los tres tabs, la
//barra inferior con la leyenda, las 13 funciones de carga, el useEffect de errorD/errorCSP y el
//submButton) vive en layoutExpediente.js. Aca queda lo de la edicion: su titulo, las capacidades de los
//tres tabs, sus tres botones (los dos de guardar y el de borrar), el Modal de borrar y su carga de datos.
//Los imports que se sacan (Collapse, Form, FaExclamationTriangle, DatosExp, TramiteExp, Pestaña3_Exp,
//useState) son los que ahora renderiza el layout, o los que quedaron sin uso al borrar las declaraciones
//muertas. Los comentarios de la fase 2 que explicaban por que la edicion usa los formularios fusionados
//quedan documentados en el encabezado de layoutExpediente.js.
import LayoutExpediente from "./layoutExpediente";

import { toast } from "react-toastify";
import { construirPayload } from "./expedientePayload";
import useExpedienteForm from "../hooks/useExpedienteForm";

const Grupo_EditExpediente = ({ editRegistro, setEdit }) => {

	const { getProfile, roleA, setRoleA, original, cambioOriginal, sesionT, geom, cambioGeom } = useContext(SessionContext);
  	
  	const name = roleA.username;
	const role = roleA.roleA;
	

  	const handleClose = () => setShow(false);//cierra la ventana, pero no elimina el expediente
  	const handleShow = () => setShow(true);//
	

	//***********EFECTOS */
	//25-abr-2023
	useEffect(()=>{
		setInputs({ ...inputs, datos_22_geom: JSON.stringify(geom) });
		setGeomB("true");		
	}, [geom])

	//**06-10-2022** verificar token al entrar a la edicion deexpediente
  	useEffect(() => {
		const pagina = 'acceso_pagina';
		//getProfile(pagina);
		if(sesionT === 'no_token'){
			alert('volver a loguear');
			setEdit(false);
		} else if( sesionT === 'Token valido'){
			//console.log("59--> ","token valido" );
			setEdit(true);
		}
		
  	}, []);
	//*** cierra chequear token ****//22-09-2022

	//***Guardar y Continuar*** 06/10/2022
  	const redirect_Cont = async e => {
		//console.log(e.target);
		try{
			const x = 'continuar';
			//await getProfile(x);
			if(sesionT === 'no_token'){
				alert('volver a loguear');
			} else if( sesionT === 'Token valido'){
				//console.log("82--> ","token valido" );
				//saveSeguir(e);// si el token es válido, ejecutar saveExit
				saveSeguir_prueba(e);
			}
		} catch(err){
			console.error(err);
		}
	}

	//**Recuperar el valor recibido en editRegistro, para la pestaña de Datos--->Paso "A"
	const { id_exp_prueba, nombre_proyecto, expediente,
		fecha_carga, fecha_caratulacion,
		fecha_actualizacion, //add 25-abr-2024
		datos_05_responsable, tramite_prioritario, avanzados, programa, estado, tipo, partido, localidad, cantidad_lotes,
		cantidad_lotes_adjudicables, porc_lotes_municipales, lotes_adquiridos_municipio,
		datos_18_sintesis_nomenclatura,
		titular_tierra, plano_oficial, area, zonificacion, nro_ordenanza_vigente, decreto_promulgatorio,
		sistema_agua, eliminacion_excretas, observaciones_generales,
		datos_19_partido_nomencla,
		datos_20_circ_nomencla,
		datos_21_secc_nomencla,
		datos_22_geom
	} = editRegistro;
	
  	const { array_csp } = editRegistro;
	
	const {
		csp_1_tamaño_medio_lotes_residenciales,
		csp_2_actor_encargado_obras_infra,
		csp_3_financiamiento_publico_obras_infra,
		csp_4_jurisdiccion_infra,
		csp_5_organismo_financiamiento_infra,
		csp_6_fecha_control_infra,
		csp_7_descripcion_obras_infra,
		csp_8_financiamiento_publico_obras_viv,
		csp_9_jurisdiccion_viv,
		csp_10_organismo_financiamiento_viv,
		csp_11_fecha_control_viv,
		csp_12_descripcion_obras_viv,
		csp_13_financiamiento_publico_obras_equip,
		csp_14_jurisdiccion_equip,
		csp_15_organismo_financiamiento_equip,
		csp_16_fecha_control_equip,
		csp_17_descripcion_obras_equip,
		csp_18_pl_mensura_estado,
		csp_19_pl_mensura_partido,
		csp_20_pl_mensura_orden,
		csp_21_pl_mensura_año,
		csp_22_pl_mensura_fecha,
		csp_23_registracion_legajo,
		csp_24_registracion_folio,
		csp_25_registracion_fecha,
		csp_26_fecha_control,
		csp_27_observaciones_csp,
		csp_28_presencia_apertura_calles,
		csp_29_parc_edificadas,
		csp_30_porcentaje_parc_edificadas,
		csp_31_observ_seguimiento_obras_y_edificacion,
		csp_32_fecha_control_seguimiento_obras,
		csp_33_censos_jsonb,//agregar destructuring para nuevos campos - 27-may-2025
		csp_34_boletos_realizados,
		csp_34_boletos_entregados,
		csp_34_boletos_en_proceso,
		csp_34_boletos_en_conflicto_adjudicatorio,
		csp_34_ultima_actualizacion_boletos,
		csp_34_fecha_entrega_boletos,
		csp_35_tramites_realizados,
		csp_35_tramites_en_proceso,
		csp_35_ultima_actualizacion_tramites,
		csp_36_observaciones_censo
	} = array_csp?.[0] || {}

	//**23-03-22: destructuring los datos catastralaes recibidos en setEditRegistro
	const { nom_catastro } = editRegistro;
	

	useEffect(()=>{
		//console.log("CAMBIO NOM");
		if(nom_catastro !== null){
			setFormRows(nom_catastro)
		} else {
			//console.log("ES NULL, NO CAMBIAR");
		}
	}, [nom_catastro]);

	//console.log(formRows);

	//**17-03-22 - Recuperar el valor recibido en editRegistro, para la pestaña de Trámites--->Paso "A"
	const {
		solicitud_adhesion_t, //101
		certif_urbanistico_municipal_t, //102
		certif_no_inundabilidad_t, //103
		anteproyecto_urbano_t, //104
		titulo_propiedad_t, //105
		informe_dominio_t, //106
		anotaciones_personales_t,//107
		admisibilidad_inicial_t,//108
		prefactibilidad_urbanistica_t,//109
		prefactibilidad_hidraulica_t,//110
		memoria_descriptiva_obras_t,//111
		energia_electrica_t, //112
		agua_potable_t, //113
		eliminacion_excretas_t, //114
		apertura_calles_t, //115
		acta_constitutiva_t, //116
		certif_vigencia_persona_juridica_t, //117
		plano_mensura_t, //118
		convenio_urbanistico_t, //119
		ordenanza_municipal_t, //120
		memoria_descriptiva_procedimientos_t, //121
		certif_tecnico_urbanistico_t, //122
		resolucion_afectacion_t, //123
		visado_plano_t, //124
		observaciones_internas_t, //125
		observaciones_reporte_t, //126
		fecha_envio_prefac_h_t, //127
		expediente_prefac_h_t, //128
		fecha_emision_prefac_h_t, //129
		fecha_visado_plano_t, //130
		fecha_envio_resol_t, //131
		fecha_emision_resol_t, //132
		numero_especial_resol_t, //133
		t_127_tramitacion_ada_prefac_h,
		t_131_observaciones_prefact_h,
		t_132_tramitacion_resol,
		t_136_observaciones_resol,
		t_137_tramitacion_visado,
		t_139_fecha_entrega, //139 - ADD 20-09-2022
    	t_140_observaciones_tramitacion, //140 - ADD 20-09-2022
		t_144_proyecto_hidraulico, //144 -- add 22-12-2022
		t_145_cpu_tramitacion, //145 --add 14-JUN-2024
		t_146_cpu_fecha_envio, //146 --add 14-JUN-2024
		t_147_cpu_fecha_emision, //147 --add 14-JUN-2024
		t_148_cpu_nro_gdeba, //148 --add 14-JUN-2024
		t_149_cpu_observaciones, //149 --add 14-JUN-2024
		
	} = editRegistro;
	//console.log("HIDRULICO --->" ,t_144_proyecto_hidraulico);

	//** 18-03-22: manejo de estado solo para fechas **
	let _fecha_carga = null;
	if(fecha_carga === null){
		_fecha_carga = null;
	} else if (fecha_carga != null && fecha_carga !== ""){		
		_fecha_carga =  new Date(fecha_carga);
		_fecha_carga.setMinutes(_fecha_carga.getMinutes() + _fecha_carga.getTimezoneOffset())
		//console.log(_fecha_carga);
	}

	let _fecha_caratulacion = null;
	if(fecha_caratulacion === null){
		_fecha_caratulacion = null;
	} else if (fecha_caratulacion != null && fecha_caratulacion !== ""){		
		_fecha_caratulacion =  new Date(fecha_caratulacion);
		_fecha_caratulacion.setMinutes(_fecha_caratulacion.getMinutes() + _fecha_caratulacion.getTimezoneOffset())
		//console.log(_fecha_caratulacion);
	}

	let _fecha_actualizacion = null;
	if(fecha_actualizacion === null){
		_fecha_actualizacion = null;
	} else if (fecha_actualizacion != null && fecha_actualizacion !== ""){		
		_fecha_actualizacion =  new Date(fecha_actualizacion);
		_fecha_actualizacion.setMinutes(_fecha_actualizacion.getMinutes() + _fecha_actualizacion.getTimezoneOffset())
		//console.log(_fecha_actualizacion);
	}

	let _127_fecha_envio_prefac_h_t = null;
	if (fecha_envio_prefac_h_t === null) {
		//console.log("ES NULL");
		_127_fecha_envio_prefac_h_t = null;
	} else if (fecha_envio_prefac_h_t != null && fecha_envio_prefac_h_t !== "") {
		_127_fecha_envio_prefac_h_t = new Date(fecha_envio_prefac_h_t);
		_127_fecha_envio_prefac_h_t.setMinutes(_127_fecha_envio_prefac_h_t.getMinutes() + _127_fecha_envio_prefac_h_t.getTimezoneOffset())
	}

	let _129_fecha_emision_prefac_h_t = null;
	if (fecha_emision_prefac_h_t === null) {
		_129_fecha_emision_prefac_h_t = null;
	} else if (fecha_emision_prefac_h_t != null && fecha_emision_prefac_h_t !== "") {
		_129_fecha_emision_prefac_h_t = new Date(fecha_emision_prefac_h_t);
		_129_fecha_emision_prefac_h_t.setMinutes(_129_fecha_emision_prefac_h_t.getMinutes() + _129_fecha_emision_prefac_h_t.getTimezoneOffset())
	}

	let _130_fecha_visado_plano_t = null;
	if (fecha_visado_plano_t === null) {
		//console.log("ES NULL");
		_130_fecha_visado_plano_t = null;
	} else if (fecha_visado_plano_t != null && fecha_visado_plano_t !== ""){
		//console.log("NO TIENE QUE ENTRAR SI NO ES NULL");
		_130_fecha_visado_plano_t = new Date(fecha_visado_plano_t);
		_130_fecha_visado_plano_t.setMinutes(_130_fecha_visado_plano_t.getMinutes() + _130_fecha_visado_plano_t.getTimezoneOffset())
	}

	let _131_fecha_envio_resol_t = null;
	if (fecha_envio_resol_t === null) {
		//console.log("ES NULL");
		_131_fecha_envio_resol_t = null;
	} else if (fecha_envio_resol_t != null && fecha_envio_resol_t !== ""){
		_131_fecha_envio_resol_t = new Date(fecha_envio_resol_t);
		_131_fecha_envio_resol_t.setMinutes(_131_fecha_envio_resol_t.getMinutes() + _131_fecha_envio_resol_t.getTimezoneOffset())
	}

 	let _132_fecha_emision_resol_t = null;
	if (fecha_emision_resol_t === null) {
		//console.log("ES NULL");
		_132_fecha_emision_resol_t = null;
	} else if (fecha_emision_resol_t != null && fecha_emision_resol_t !== ""){
		_132_fecha_emision_resol_t = new Date(fecha_emision_resol_t);
		_132_fecha_emision_resol_t.setMinutes(_132_fecha_emision_resol_t.getMinutes() + _132_fecha_emision_resol_t.getTimezoneOffset())
		//console.log("CAMBIO?", _132_fecha_emision_resol_t)
	}

	let _t_139_fecha_entrega = null;
	if (t_139_fecha_entrega === null) {
		_t_139_fecha_entrega = null;
	} else if (t_139_fecha_entrega != null && t_139_fecha_entrega !== ""){
		_t_139_fecha_entrega = new Date(t_139_fecha_entrega);
		_t_139_fecha_entrega.setMinutes(_t_139_fecha_entrega.getMinutes() + _t_139_fecha_entrega.getTimezoneOffset())
	}


	let _csp_25_registracion_fecha = null;
	if (csp_25_registracion_fecha === null) {
		_csp_25_registracion_fecha = null;
	} else if (csp_25_registracion_fecha != null && csp_25_registracion_fecha !== ""){
		_csp_25_registracion_fecha = new Date(csp_25_registracion_fecha+"T00:00:00");
	}

	//+++ 02-jun-2024
	let _csp_32_fecha_control_seguimiento_obras=null;
	if(csp_32_fecha_control_seguimiento_obras===null){
		_csp_32_fecha_control_seguimiento_obras = null;
	}else if (csp_32_fecha_control_seguimiento_obras != null && csp_32_fecha_control_seguimiento_obras !== ""){
		_csp_32_fecha_control_seguimiento_obras = new Date(csp_32_fecha_control_seguimiento_obras);
		_csp_32_fecha_control_seguimiento_obras.setMinutes(_csp_32_fecha_control_seguimiento_obras.getMinutes()+ _csp_32_fecha_control_seguimiento_obras.getTimezoneOffset())
	}
	//--cierra manejo fechas 02-jun-2024

	//+++ 14-jun-2024
	let _t_146_cpu_fecha_envio=null;
	if(t_146_cpu_fecha_envio===null){
		_t_146_cpu_fecha_envio=null;
	} else if (t_146_cpu_fecha_envio != null && t_146_cpu_fecha_envio !== ""){
		_t_146_cpu_fecha_envio = new Date(t_146_cpu_fecha_envio);
		_t_146_cpu_fecha_envio.setMinutes(_t_146_cpu_fecha_envio.getMinutes()+_t_146_cpu_fecha_envio.getTimezoneOffset())
	}

	let _t_147_cpu_fecha_emision=null;
	if(t_147_cpu_fecha_emision===null){
		_t_147_cpu_fecha_emision=null;
	} else if (t_147_cpu_fecha_emision != null && t_147_cpu_fecha_emision !== ""){
		_t_147_cpu_fecha_emision = new Date(t_147_cpu_fecha_emision);
		_t_147_cpu_fecha_emision.setMinutes(_t_147_cpu_fecha_emision.getMinutes()+_t_147_cpu_fecha_emision.getTimezoneOffset())
	}
	//--cierra manejo de fechas 14-jun-2024

	//++++ 16-08-2022
	let _csp_6_fecha_control_infra = null;
	if (csp_6_fecha_control_infra === null) {
		_csp_6_fecha_control_infra = null;
	} else if (csp_6_fecha_control_infra != null && csp_6_fecha_control_infra !== ""){
		_csp_6_fecha_control_infra =  new Date(csp_6_fecha_control_infra+"T00:00:00");
	}

	let _csp_11_fecha_control_viv = null;
	if (csp_11_fecha_control_viv === null) {
		_csp_11_fecha_control_viv = null;
	} else if (csp_11_fecha_control_viv != null && csp_11_fecha_control_viv !== ""){
		_csp_11_fecha_control_viv = new Date(csp_11_fecha_control_viv+"T00:00:00");
	}

	let _csp_16_fecha_control_equip = null;
	if (csp_16_fecha_control_equip === null) {
		_csp_16_fecha_control_equip = null;
	} else if (csp_16_fecha_control_equip != null && csp_16_fecha_control_equip !== ""){
		_csp_16_fecha_control_equip = new Date(csp_16_fecha_control_equip+"T00:00:00");
	}

	let _csp_22_pl_mensura_fecha = null;
	if (csp_22_pl_mensura_fecha === null) {
		_csp_22_pl_mensura_fecha = null;
	} else if (csp_22_pl_mensura_fecha != null && csp_22_pl_mensura_fecha !== ""){
		_csp_22_pl_mensura_fecha = new Date(csp_22_pl_mensura_fecha+"T00:00:00");
	}

	/*let _csp_25_registracion_fecha = null;
	if (csp_25_registracion_fecha === null) {
		_csp_25_registracion_fecha = null;
	} else if (csp_25_registracion_fecha != null && csp_25_registracion_fecha !== ""){
		_csp_25_registracion_fecha = new Date(csp_25_registracion_fecha+"T00:00:00");
		//console.log(_csp_25_registracion_fecha);
	}*/

	let _csp_26_fecha_control = null;

	if (csp_26_fecha_control === null) {
		_csp_26_fecha_control = null;
	} else if (csp_26_fecha_control != null && csp_26_fecha_control !== ""){
		_csp_26_fecha_control = new Date(csp_26_fecha_control+"T00:00:00");
	}

	//}
	//---cierra manejo fechas 16-08-2022

  //ESTADOS inputs --> pestaña Datos
	const form = useExpedienteForm({
		show: false,
		geomB: "false",
		censos: csp_33_censos_jsonb ?? [],
		boletos: {
		entregados: csp_34_boletos_entregados,
		realizados: csp_34_boletos_realizados,
		enProceso: csp_34_boletos_en_proceso,
		enConflictoAdjudicatorio: csp_34_boletos_en_conflicto_adjudicatorio,
		ultimaActualizacionBoletos: csp_34_ultima_actualizacion_boletos,
		fechaEntregaBoletos: csp_34_fecha_entrega_boletos
	},
		tramites: {
		realizados: csp_35_tramites_realizados,
		enProceso: csp_35_tramites_en_proceso,
		ultimaActualizacionTramites: csp_35_ultima_actualizacion_tramites
	},
		observaciones_censo: csp_36_observaciones_censo,
		inputs: {
		estadoExp : id_exp_prueba,
		nombre_proyecto: nombre_proyecto,
		//fecha_carga: new Date().toLocaleDateString('es-AR'), //NO mostrar la fecha actual
		fecha_carga: _fecha_carga, //new Date().toLocaleDateString('es-AR'),
		fecha_caratulacion: _fecha_caratulacion, //new Date(fecha_caratulacion),
		fecha_actualizacion : _fecha_actualizacion,
		datos_05_responsable:datos_05_responsable,
		expediente: expediente,
		tramite_prioritario: eval(tramite_prioritario), //check --> tramite_prioritario: tramite_prioritario,
		avanzados: eval(avanzados),
		programa: programa,
		estado: estado,
		tipo: tipo,
		partido: partido,// estado inicial tiene que ser un numero para que no de error en la base. Espera un integer
		localidad: localidad,
		cantidad_lotes: cantidad_lotes,
		cantidad_lotes_adjudicables: cantidad_lotes_adjudicables,
		porc_lotes_municipales: porc_lotes_municipales,
		lotes_adquiridos_municipio: lotes_adquiridos_municipio,
		datos_18_sintesis_nomenclatura: datos_18_sintesis_nomenclatura,
		titular_tierra: titular_tierra,
		plano_oficial: plano_oficial,
		area: area,
		zonificacion: zonificacion,
		nro_ordenanza_vigente: nro_ordenanza_vigente,
		decreto_promulgatorio: decreto_promulgatorio,
		sistema_agua: sistema_agua,
		eliminacion_excretas: eliminacion_excretas,
		observaciones_generales: observaciones_generales,

		datos_19_partido_nomencla:datos_19_partido_nomencla,
		datos_20_circ_nomencla: datos_20_circ_nomencla,
		datos_21_secc_nomencla: datos_21_secc_nomencla,
		datos_22_geom: geom
	},
		formRows: [{
		nomenclatura_catastral:"0000000000000000000000000000000000000000000000000",
		partida_inmobiliaria:"",//"000000",
		inscripcion_dominial:"",//"",
		nomencla_partido:"",//"000",
		nomencla_circ:"",//"00",
		nomencla_secc:"",//"00",
		nomencla_chacra_nro:"", nomencla_chacra_l:"",//"000",
		nomencla_quinta_nro:"", nomencla_quinta_l:"",//"000",
		nomencla_fracc_nro:"", nomencla_fracc_l:"",//"000",
		nomencla_manz_nro:"", nomencla_manz_l:"",//"000",
		nomencla_parc_nro:"", nomencla_parc_l:"",//"0000",
		solicitado:""
	}],
		inputsTram: {
		solicitud_adhesion_t: eval(solicitud_adhesion_t), //101
		certif_urbanistico_municipal_t: eval(certif_urbanistico_municipal_t), //102
		certif_no_inundabilidad_t: eval(certif_no_inundabilidad_t), //103
		anteproyecto_urbano_t: eval(anteproyecto_urbano_t), //104
		titulo_propiedad_t: eval(titulo_propiedad_t), //105
		informe_dominio_t: eval(informe_dominio_t), //106
		anotaciones_personales_t: eval(anotaciones_personales_t), //107
		admisibilidad_inicial_t: eval(admisibilidad_inicial_t), //108
		prefactibilidad_urbanistica_t: eval(prefactibilidad_urbanistica_t), //109
		prefactibilidad_hidraulica_t: eval(prefactibilidad_hidraulica_t), //110
		memoria_descriptiva_obras_t: eval(memoria_descriptiva_obras_t), //111
		energia_electrica_t: eval(energia_electrica_t), //112
		agua_potable_t: eval(agua_potable_t), //113
		eliminacion_excretas_t: eval(eliminacion_excretas_t), //114
		apertura_calles_t: eval(apertura_calles_t), //115
		acta_constitutiva_t: eval(acta_constitutiva_t), //116
		certif_vigencia_persona_juridica_t: eval(certif_vigencia_persona_juridica_t), //117
		plano_mensura_t: eval(plano_mensura_t), //118
		convenio_urbanistico_t: eval(convenio_urbanistico_t), //119
		ordenanza_municipal_t: eval(ordenanza_municipal_t), //120
		memoria_descriptiva_procedimientos_t: eval(memoria_descriptiva_procedimientos_t), //121
		certif_tecnico_urbanistico_t: eval(certif_tecnico_urbanistico_t), //122
		resolucion_afectacion_t: eval(resolucion_afectacion_t), //123
		visado_plano_t: eval(visado_plano_t), //124
		observaciones_internas_t: observaciones_internas_t,//125
		observaciones_reporte_t: observaciones_reporte_t,//126
		//fecha_envio_prefac_u_t:"",
		//expediente_prefac_u_t:"",
		//fecha_emision_prefac_u_t:"",

		fecha_envio_prefac_h_t: _127_fecha_envio_prefac_h_t, //127 se agregan las fechas a los inputs
		expediente_prefac_h_t: expediente_prefac_h_t, //128
		fecha_emision_prefac_h_t: _129_fecha_emision_prefac_h_t, //129 se agregan las fechas a los inputs

		fecha_visado_plano_t: _130_fecha_visado_plano_t, //130 se agregan las fechas a los inputs, previa validacion

		fecha_envio_resol_t: _131_fecha_envio_resol_t, //131 se agregan las fechas a los inputs
		fecha_emision_resol_t: _132_fecha_emision_resol_t, //132 se agregan las fechas a los inputs
		numero_especial_resol_t: numero_especial_resol_t, //133
		t_127_tramitacion_ada_prefac_h: t_127_tramitacion_ada_prefac_h,
		t_131_observaciones_prefact_h: t_131_observaciones_prefact_h,
		t_132_tramitacion_resol: t_132_tramitacion_resol,
		t_136_observaciones_resol: t_136_observaciones_resol,
		t_137_tramitacion_visado: t_137_tramitacion_visado,
		t_139_fecha_entrega: _t_139_fecha_entrega, //139 - ADD 20-09-2022
    	t_140_observaciones_tramitacion: t_140_observaciones_tramitacion, //140 - ADD 20-09-2022
		t_144_proyecto_hidraulico: eval(t_144_proyecto_hidraulico), //144 -- add 22-12-2022

		t_145_cpu_tramitacion: t_145_cpu_tramitacion, //145 --add 14-JUN-2024
		t_146_cpu_fecha_envio: _t_146_cpu_fecha_envio, //146 --add 14-JUN-2024
		t_147_cpu_fecha_emision: _t_147_cpu_fecha_emision, //147 --add 14-JUN-2024
		t_148_cpu_nro_gdeba: t_148_cpu_nro_gdeba, //148 --add 14-JUN-2024
		t_149_cpu_observaciones: t_149_cpu_observaciones, //149 --add 14-JUN-2024
	},
		inputsCSP: {
		csp_1_tamaño_medio_lotes_residenciales : csp_1_tamaño_medio_lotes_residenciales,
		csp_2_actor_encargado_obras_infra : csp_2_actor_encargado_obras_infra,
		csp_3_financiamiento_publico_obras_infra: eval(csp_3_financiamiento_publico_obras_infra), 	//------check
		csp_4_jurisdiccion_infra : csp_4_jurisdiccion_infra,
		csp_5_organismo_financiamiento_infra : csp_5_organismo_financiamiento_infra,
		csp_6_fecha_control_infra : _csp_6_fecha_control_infra,//date
		csp_7_descripcion_obras_infra : csp_7_descripcion_obras_infra,
		csp_8_financiamiento_publico_obras_viv: eval(csp_8_financiamiento_publico_obras_viv), 	//-----check
		csp_9_jurisdiccion_viv : csp_9_jurisdiccion_viv,
		csp_10_organismo_financiamiento_viv : csp_10_organismo_financiamiento_viv,
		csp_11_fecha_control_viv: _csp_11_fecha_control_viv, //date
		csp_12_descripcion_obras_viv : csp_12_descripcion_obras_viv,
		csp_13_financiamiento_publico_obras_equip: eval(csp_13_financiamiento_publico_obras_equip), 	//-----check
		csp_14_jurisdiccion_equip : csp_14_jurisdiccion_equip,
		csp_15_organismo_financiamiento_equip : csp_15_organismo_financiamiento_equip,
		csp_16_fecha_control_equip: _csp_16_fecha_control_equip, //date
		csp_17_descripcion_obras_equip : csp_17_descripcion_obras_equip,
		csp_18_pl_mensura_estado : csp_18_pl_mensura_estado,
		csp_19_pl_mensura_partido : csp_19_pl_mensura_partido,
		csp_20_pl_mensura_orden : csp_20_pl_mensura_orden,
		csp_21_pl_mensura_año : csp_21_pl_mensura_año,
		csp_22_pl_mensura_fecha: _csp_22_pl_mensura_fecha, //date
		csp_23_registracion_legajo : csp_23_registracion_legajo,
		csp_24_registracion_folio : csp_24_registracion_folio,
		csp_25_registracion_fecha: _csp_25_registracion_fecha, //date _csp_25_registracion_fecha
		csp_26_fecha_control: _csp_26_fecha_control, //date
		csp_27_observaciones_csp : csp_27_observaciones_csp,
		csp_28_presencia_apertura_calles : csp_28_presencia_apertura_calles,
		csp_29_parc_edificadas : csp_29_parc_edificadas,
		csp_30_porcentaje_parc_edificadas : csp_30_porcentaje_parc_edificadas,
		csp_31_observ_seguimiento_obras_y_edificacion : csp_31_observ_seguimiento_obras_y_edificacion,
		csp_32_fecha_control_seguimiento_obras : _csp_32_fecha_control_seguimiento_obras
	},
		errorD: false,
		errorCSP: false,
		resultError: undefined,
		openExpediente: true,
		openTramite: false,
		openPestaña3: false,
	});
	//EX 15-10-2026 (fase 3 - paso 3): el cascaron usa del hook solo estos nombres. El resto (los setters
	//de los tabs, los tres open*, errorD/errorCSP, y los estados de un solo flujo como geomB) los usa el
	//layout, que recibe el objeto entero en la prop form. Los de aca son los que necesitan la carga de
	//datos, el payload del guardado, el Modal de borrar y los botones de guardar.
	//OJO con boletos/tramites/formRows/observaciones_censo: el payload los usa en forma corta dentro de un
	//objeto literal (construirPayload({ ..., boletos, tramites, ... })), y ahi la forma corta SI es una
	//referencia. Una medicion por AST los habia dado por no usados (salteaba el value de toda
	//ObjectProperty como si fuera un patron de destructuring) y ESLint lo cazo con 5 no-undef. Esa es la
	//razon de que esten aca.
	const {
		inputs, setInputs,
		inputsTram, inputsCSP,
		censos, boletos, tramites, formRows, observaciones_censo,
		resultError,
		setFormRows, setGeomB,
		show, setShow,
	} = form;
	//console.log(inputs);

	//**11jul24 */

	//estados de tramites

	//console.log(inputsCSP);

	//nuevos 28-mayo-2025: son de inputCSP, pero manejarlos por separado

	//cierra nuevos	

	/*
	*** USAR para cargar select desde datos externos
	const getPartidos = async () => {
		const urlPartidos = `http://geo.arba.gov.ar/datoabierto/partidos`;

		const res = await fetch(urlPartidos)
		.then(res => res.json())
		.then(res => setOptionsPartido(res))
		.catch(err => console.log(err));
	}

	useEffect(() => {
                getPartidos();
        },[]);
	*/

	const onSubmitForm = async e => {
    		e.preventDefault();
			//console.log("ACÁ ???")    		
	};

	const borrarRegistro_SI = async e => {
		e.preventDefault();
		
		const { estadoExp,
			nombre_proyecto, expediente,
			fecha_carga, fecha_caratulacion,
			datos_05_responsable, tramite_prioritario, avanzados,
			programa, estado,
			tipo, partido,
			localidad, cantidad_lotes,
			cantidad_lotes_adjudicables,
			porc_lotes_municipales, lotes_adquiridos_municipio,
			datos_18_sintesis_nomenclatura,
			titular_tierra, plano_oficial,
			area, zonificacion,
			nro_ordenanza_vigente, decreto_promulgatorio,
			sistema_agua, eliminacion_excretas,
			observaciones_generales,
			//nameB,//ADD 01-nov-2022 para identificar usuario
		} = inputs; //---> viene de Datos Generales
		//console.log(inputs);

		const {
			solicitud_adhesion_t,
			certif_urbanistico_municipal_t, certif_no_inundabilidad_t, anteproyecto_urbano_t,
			titulo_propiedad_t, memoria_descriptiva_obras_t, energia_electrica_t, prefactibilidad_urbanistica_t,
			agua_potable_t, eliminacion_excretas_t, apertura_calles_t, acta_constitutiva_t, certif_vigencia_persona_juridica_t,
			plano_mensura_t, convenio_urbanistico_t, ordenanza_municipal_t, memoria_descriptiva_procedimientos_t, informe_dominio_t,
			anotaciones_personales_t, admisibilidad_inicial_t, prefactibilidad_hidraulica_t, certif_tecnico_urbanistico_t,
			resolucion_afectacion_t, visado_plano_t,
			observaciones_internas_t,
			observaciones_reporte_t,
			fecha_envio_prefac_h_t, expediente_prefac_h_t, fecha_emision_prefac_h_t,
			fecha_envio_resol_t, fecha_emision_resol_t, numero_especial_resol_t,
			t_127_tramitacion_ada_prefac_h,
			t_131_observaciones_prefact_h,
			t_132_tramitacion_resol,
			t_136_observaciones_resol,
			t_137_tramitacion_visado,
			fecha_visado_plano_t,
			t_139_fecha_entrega,
			t_140_observaciones_tramitacion,
			t_144_proyecto_hidraulico, //144 -- add 22-12-2022
			t_145_cpu_tramitacion, //145 --add 14-JUN-2024
			t_146_cpu_fecha_envio, //146 --add 14-JUN-2024
			t_147_cpu_fecha_emision, //147 --add 14-JUN-2024
			t_148_cpu_nro_gdeba, //148 --add 14-JUN-2024
			t_149_cpu_observaciones, //149 --add 14-JUN-2024
		}= inputsTram;

		try {
			const body = {
				name,
				inputs,
				inputsTram,
				inputsCSP,
				formRows
			}
			//console.log(body);
			//console.log(body.inputs.estadoExp);

			const response = await fetch(
				`/api/authentication/borrar_expediente`,
				{
				method: "POST",
				headers: {
					"Content-type": "application/json"
				},
				body: JSON.stringify(body)
				}
			);
			//console.log(response);
			const parseRes = await response.json();
			//console.log(parseRes);

			/*if (parseRes.id === 'error'){
				toast.error('Ocurrio un problema al borrar el expediente');

			} else*/ if (response.ok && parseRes && parseRes.id !== 'error'){
				//EX 15-09-2026: la respuesta es la fila del expediente borrado. Antes el chequeo era
				//`if (parseRes.expediente)`: como el nro. de expediente es opcional, si venia vacio el
				//string vacio es falsy y mostraba "Ocurrio un problema al borrar el expediente" aunque
				//el borrado se hubiera hecho bien.
				toast.success(parseRes.expediente
					? `Expediente ${parseRes.expediente} eliminado!!`
					: 'Expediente eliminado!!');
				setShow(false);
				setEdit(false); //20-04-2022

			} else {
				toast.error('Ocurrio un problema al borrar el expediente');
			}

		} catch(err){
			console.error(err.message);
		}

	}//cierra borrarRegistro - 04-agos-2022


	const saveSeguir_prueba = async (e) => {
		e.preventDefault();

		const censosEnviar = censos.map(item => {
			let fechaFormateada = item.fechaCenso;
			
			// Si es un objeto Date
			if (fechaFormateada instanceof Date) {
				fechaFormateada = fechaFormateada.toISOString().split('T')[0];
			}
			// Si es un string ISO (contiene 'T')
			else if (typeof fechaFormateada === 'string' && fechaFormateada.includes('T')) {
				fechaFormateada = fechaFormateada.split('T')[0];
			}
			// Si ya está en formato YYYY-MM-DD o es null/undefined, lo dejamos igual			
			return {
				...item,
				fechaCenso: fechaFormateada
			};
		});

		const { estadoExp,
			nombre_proyecto, expediente,
			fecha_carga, fecha_caratulacion,// fecha_actualizacion se calcula en el server
			datos_05_responsable, tramite_prioritario, avanzados,
			programa, estado,
			tipo, partido,
			localidad, cantidad_lotes,
			cantidad_lotes_adjudicables,
			porc_lotes_municipales, lotes_adquiridos_municipio,
			datos_18_sintesis_nomenclatura,
			titular_tierra, plano_oficial,
			area, zonificacion,
			nro_ordenanza_vigente, decreto_promulgatorio,
			sistema_agua, eliminacion_excretas,
			observaciones_generales,
			datos_19_partido_nomencla, datos_20_circ_nomencla, datos_21_secc_nomencla,
			datos_22_geom
		} = inputs; //---> viene de Datos Generales

		const {
			solicitud_adhesion_t,
			certif_urbanistico_municipal_t, certif_no_inundabilidad_t, anteproyecto_urbano_t,
			titulo_propiedad_t, memoria_descriptiva_obras_t, energia_electrica_t, prefactibilidad_urbanistica_t,
			agua_potable_t, eliminacion_excretas_t, apertura_calles_t, acta_constitutiva_t, certif_vigencia_persona_juridica_t,
			plano_mensura_t, convenio_urbanistico_t, ordenanza_municipal_t, memoria_descriptiva_procedimientos_t, informe_dominio_t,
			anotaciones_personales_t, admisibilidad_inicial_t, prefactibilidad_hidraulica_t, certif_tecnico_urbanistico_t,
			resolucion_afectacion_t, visado_plano_t,
			observaciones_internas_t,//125
			observaciones_reporte_t,//126
			fecha_envio_prefac_h_t, expediente_prefac_h_t, fecha_emision_prefac_h_t,
			fecha_envio_resol_t, fecha_emision_resol_t, numero_especial_resol_t,
			t_127_tramitacion_ada_prefac_h,
			t_131_observaciones_prefact_h,
			t_132_tramitacion_resol,
			t_136_observaciones_resol,
			t_137_tramitacion_visado,
			fecha_visado_plano_t,
			t_139_fecha_entrega, //139 - ADD 20-09-2022
	    	t_140_observaciones_tramitacion,
			t_144_proyecto_hidraulico, //144 -- add 22-12-2022
			t_145_cpu_tramitacion, //145 --add 14-JUN-2024
			t_146_cpu_fecha_envio, //146 --add 14-JUN-2024
			t_147_cpu_fecha_emision, //147 --add 14-JUN-2024
			t_148_cpu_nro_gdeba, //148 --add 14-JUN-2024
			t_149_cpu_observaciones, //149 --add 14-JUN-2024
		}= inputsTram;

		const body = construirPayload({
				...inputs, ...inputsTram, ...inputsCSP,
				inputsCSP, boletos, tramites, formRows, observaciones_censo, censosEnviar, estadoExp, name,
			});

		const url = `/api/authentication/edit_simplificada`;

		const headers = {  'Content-Type': 'application/json', 'Authorization': localStorage.tokenT, roleT: localStorage.roleT, username:localStorage.username }

		const options = {
			method: "POST",
			headers: headers,
			body: JSON.stringify(body)
		}

		let response = await fetch(url, {
			method: 'POST',
			body: JSON.stringify(body),
			headers:{ Accept: "application/json", 'Content-Type': 'application/json', 'Authorization': localStorage.tokenT, roleT: localStorage.roleT, username:localStorage.username }
		});
		
		if(response.ok){
			const parseRes = await response.json();
			
			if (parseRes.id === undefined){ //cuando el estado es 'nuevo' y se ingresa un expediente que ya existe
				//console.log('1');
				toast.error(`El expediente ya existe, intente nuevamente.`); //NO SALIR, para permitir cambiar el nro de expediente

			} else if (parseRes.id !== parseRes.id_exp_prueba && parseRes.id !== 'error'){
				//console.log('2');
				toast.success(`Se actualizo el expediente ${parseRes.expediente}.`);
				//EX 21-09-2026: la fecha de actualizacion que devuelve el server tiene que llegar al
				//estado, que es de donde la lee el Tab 1 (inputs -> fecha_actualizacion). Sin esto la fecha
				//guardada no se veia hasta salir y volver a entrar (reportado por el usuario; ya pasaba en prod).
				const _fa = parseRes.fecha_actualizacion ? new Date(parseRes.fecha_actualizacion) : null;
				//EX 21-09-2026: el estado de la EDICION guarda un Date, no un string: el Tab 1 lo pasa
				//crudo al DatePicker (fechasTalCualVienen) y con un string tira 'Invalid time value'.
				//Se normaliza igual que al cargar el expediente (linea ~244).
				if (_fa) { _fa.setMinutes(_fa.getMinutes() + _fa.getTimezoneOffset()); }
				setInputs({ ...inputs, fecha_actualizacion: _fa });
				cambioOriginal(0);
				if (e.target.id ==="but_save_e2"){ // SI EL EVENTO SE PRIDUCE DESDE ESTE ID ---> cambia el estado a Edit = false 05-08-2022
					setEdit(false); //20-04-2022
				}

			} else if (parseRes.id !== undefined && parseRes.id === parseRes.id_exp_prueba ){
				//console.log('3');
				//console.log(parseRes.expediente);
				toast.success(`Expediente ${parseRes.expediente} creado correctamente!!`);
				//EX 21-09-2026: la fecha de actualizacion que devuelve el server tiene que llegar al
				//estado, que es de donde la lee el Tab 1 (inputs -> fecha_actualizacion). Sin esto la fecha
				//guardada no se veia hasta salir y volver a entrar (reportado por el usuario; ya pasaba en prod).
				const _fa = parseRes.fecha_actualizacion ? new Date(parseRes.fecha_actualizacion) : null;
				//EX 21-09-2026: el estado de la EDICION guarda un Date, no un string: el Tab 1 lo pasa
				//crudo al DatePicker (fechasTalCualVienen) y con un string tira 'Invalid time value'.
				//Se normaliza igual que al cargar el expediente (linea ~244).
				if (_fa) { _fa.setMinutes(_fa.getMinutes() + _fa.getTimezoneOffset()); }
				setInputs({ ...inputs, fecha_actualizacion: _fa });
				cambioOriginal(0)
				if (e.target.id ==="but_save_e2"){
					setEdit(false); //20-04-2022 // SI EL EVENTO SE PRIDUCE DESDE ESTE ID ---> cambia el estado a Edit = false 05-08-2022
				}

			} else if (parseRes.id=== 'error' && parseRes.message === 'Ha ocurrido un error'){
				//console.log('6');
				toast.error(`Ocurrió un error al editar el expediente.`);

			} else if (parseRes.id=== 'error' && parseRes.message === 'Ha ocurrido un error'){
				//console.log('7');
				toast.error(`Ocurrió un error, por favor intente nuevamente. Si el problema continua comunicarse con un administrador`);
			} else {
				//console.log('4');
				//console.log("error");
				toast.error(parseRes);
			}
		} else {
			//console.log('Respuesta de red OK pero respuesta de HTTP no OK');
		}
	}

  	//EX 15-10-2026 (fase 3 - paso 3): el Cancelar de la edicion. Antes lo ponia la barra que renderizaba
	//tablaExp.js (cancelEdit: e.preventDefault() + setEdit(false) + cambioOriginal(0) cuando esta
	//editando, que es el unico caso en que esta pantalla esta montada). Ahora la barra la renderiza el
	//layout compartido, asi que el handler vive en la pantalla que sabe como salir de la edicion.
	const cancelarEdicion = (e) => {
		e.preventDefault();
		setEdit(false);
		cambioOriginal(0);
	}

return (
		<Fragment>

			{/*EX 15-10-2026 (fase 3 - paso 3): la edicion es un cascaron del layout compartido. Lo propio
			   de este flujo entra por props: el titulo, las capacidades de los tres tabs, los tres botones
			   (los dos de guardar y el de Borrar, que abre el Modal) y el Modal.
			   El estado del formulario para la barra sale de la MISMA regla que usa el alta (si el
			   expediente ya esta en la base, es EDICIÓN). El onSubmit del Form es el de la edicion.
			   NO hay <div className="main"> ni <Footer/> aca: la edicion se monta adentro de la pantalla
			   de inicio, que es la dueña de .main y del pie (inicio.js:407 y 534).*/}
			<LayoutExpediente
				form={form}
				name={name}
				titulo="Actualizar Expediente"
				estadoFormulario={id_exp_prueba ? "EDICIÓN" : "NUEVO"}
				onCancelar={cancelarEdicion}
				onSubmit={onSubmitForm}
				capacidadesDatos={{
					precargarDatos: true,
					partidoBloqueado: true,
					fechasTalCualVienen: true,
					tituloMapa: "Editar polígono",
					sufijoId: "E",
				}}
				capacidadesTramite={{
					precargarDatos: true,
					limpiarProyHidraulicoEnUrbana: false,
					deshabilitarAnotacionesPorTipo: true,
				}}
				capacidadesPestaña3={{
					planos: editRegistro.planos,
					precargarDatos: true,
					evalEnCheckboxesFinanciamiento: true,
					sembrarPlanosEnInputsCSP: true,
					normalizarFechasPrecargadas: true,
					alturaAutoEnColumnasFinanciamiento: true,
				}}
				botones={
					<Fragment>
						<Button type="button" form='my-form'  id="but_save_c1" style={{ }} disabled={ role ==="visualizador" || role==="user" || original ===0 || sesionT ==='no_token' || resultError===true ? true : false } className="btn btn-success btn-block button_verde" onClick={redirect_Cont} >Guardar y Continuar</Button> {/*backgroundColor: "#592673", border:"#592673"*/}
						<Button type="button" id="but_save_e2" style={{ }} disabled={ role ==="visualizador" || role==="user" || original ===0 || sesionT ==='no_token'|| resultError===true ? true : false } className="btn btn-success btn-block button_verde" onClick={redirect_Cont} >Guardar y Salir</Button> {/* backgroundColor: "#592673", border:"#592673" */}
						<Button type="button" id="but_del_e1" style={{ }} disabled={ sesionT ==='no_token' || resultError===true ? true : false } className={ role==="admin" && sesionT !=="no_token" ? "btn btn-success btn-block button_rojo" : "btn hidden_button"} onClick={handleShow} >Borrar</Button> {/* backgroundColor: "red", border: "red"*/}
					</Fragment>
				}
				modal={
					<Modal
						id="id_modal_1"
						show={show}
						onHide={handleClose}
						backdrop="static"
						keyboard={false}
						className="id_modal_1"
						style={{top: "200"}}
					>
						<Modal.Header style={{background: "rgb(0,174,195)", color:"white"}} closeButton>
							<Modal.Title>Confirmar</Modal.Title>
						</Modal.Header>
						<Modal.Body>
							<p>Borrar expediente? {expediente}</p>
						</Modal.Body>
						<Modal.Footer>
							<Button className="btn btn-success btn-block button_verde" onClick={borrarRegistro_SI}>
								Aceptar
							</Button>
							<Button className="btn btn-success btn-block button_verde" onClick={handleClose}>
								Cancelar
							</Button>
						</Modal.Footer>
					</Modal>
				}
			/>

		{/* </div> */}
  </Fragment>
  );
};

export default Grupo_EditExpediente;
